import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btn-con" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "btn-text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "btn-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" })
], -1)

import { ref, computed } from 'vue'
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadCV',
  setup(__props) {

  const { locale } = useI18n();
  const cv_file = process.env.VUE_APP_CV_FILE

  const isRTL = computed(() => {
  return locale.value === 'ar'; // 'ar' is the code for Arabic
  });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _unref(cv_file),
      class: "main-btn",
      id: "download-cv",
      download: "wissem_zeddini_cv",
      target: "_blank",
      rel: "noopener noreferrer"
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('download_cv')), 1),
      _hoisted_4
    ], 8, _hoisted_2)
  ]))
}
}

})